import React from "react";

const RichGrid = ({ element }) => {
  if (!element.components || element.components.length === 0) {
    return <div>Rich Grid</div>;
  }

  return (
    <div className="w_100 hover_arrow" style={{ marginTop: "-4px" }}>
      <div className="w_100 overflow_auto">
        <table className="w_100">
          <thead>
            <tr>
              {element.components.map((component) => (
                <th key={component.id} className="border_full px_4 py_2 text_left font_weight_medium">
                  {component.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {element.components.map((component) => (
                <td key={component.id} className="border_full" style={{ padding: "12px 18px" }}></td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RichGrid;
